<template>
  <div class="nav-root" :class="{ 'is-open': !!activeMenu || mobileOpen }">
    <header class="nav-shell" @mouseenter="cancelClose" @mouseleave="scheduleClose">
      <div class="nav-bar">
        <div class="nav-bar-inner">
          <div class="nav-logo" @click="routerpush('/')">
            <img src="../../static/home/logo.png" alt="PrimeForce">
          </div>

          <nav v-if="!isMobile" class="nav-list">
            <div
              v-for="item in menus"
              :key="item.key"
              class="nav-item"
              :class="{ 'is-active': activeMenu === item.key }"
              @mouseenter="openMenu(item.key)"
              @click="routerpush(item.path)"
            >
              {{ item.title }}
            </div>
          </nav>

          <div v-if="!isMobile" class="nav-actions">
            <span class="nav-lang" :class="{ 'is-active': locale === 'zh' }" @click="changeLanguage('zh')">简</span>
            <span class="nav-lang" :class="{ 'is-active': locale === 'en' }" @click="changeLanguage('en')">EN</span>
          </div>

          <button v-if="isMobile" class="nav-toggle" :class="{ 'is-open': mobileOpen }" @click="toggleMobile">
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      <!-- 桌面端悬停展开的下拉面板 -->
      <div v-if="!isMobile" class="nav-panels">
        <div
          v-for="item in menus"
          :key="item.key"
          class="nav-panel"
          :class="{ 'is-open': activeMenu === item.key }"
        >
          <div class="nav-panel-inner">
            <div v-for="(group, gi) in item.groups" :key="gi" class="nav-col">
              <p class="nav-col-title">{{ group.title }}</p>
              <ul class="nav-col-list">
                <li
                  v-for="(link, li) in group.links"
                  :key="li"
                  class="nav-col-link"
                  @click="routerpush(item.path)"
                >{{ link }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- 移动端菜单 -->
      <div v-if="isMobile" class="nav-mobile" :class="{ 'is-open': mobileOpen }">
        <div class="nav-mobile-inner">
          <div v-for="item in menus" :key="item.key" class="nav-mobile-item">
            <div class="nav-mobile-head" @click="toggleMobileSection(item.key)">
              <span>{{ item.title }}</span>
              <i class="nav-mobile-arrow" :class="{ 'is-open': mobileSection === item.key }"></i>
            </div>
            <div class="nav-mobile-sub" :class="{ 'is-open': mobileSection === item.key }">
              <template v-for="(group, gi) in item.groups">
                <p :key="'t' + gi" class="nav-mobile-group">{{ group.title }}</p>
                <a
                  v-for="(link, li) in group.links"
                  :key="gi + '-' + li"
                  class="nav-mobile-link"
                  @click="routerpush(item.path)"
                >{{ link }}</a>
              </template>
            </div>
          </div>

          <div class="nav-mobile-lang">
            <span :class="{ 'is-active': locale === 'zh' }" @click="changeLanguage('zh')">{{ navMenu.langZh }}</span>
            <span :class="{ 'is-active': locale === 'en' }" @click="changeLanguage('en')">{{ navMenu.langEn }}</span>
          </div>
        </div>
      </div>
    </header>

    <!-- 遮罩放在 hover 区域之外，鼠标移出导航即自动收起菜单 -->
    <div
      class="nav-scrim"
      :class="{ 'is-open': !!activeMenu || mobileOpen }"
      @click="closeAll"
      @mouseenter="scheduleClose"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'navtop',
  data() {
    return {
      activeMenu: null, // 当前悬停展开的菜单
      mobileOpen: false, // 移动端菜单开关
      mobileSection: null, // 移动端展开的分组
      isMobile: window.innerWidth < 800,
      closeTimer: null,
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    navMenu() {
      const messages = this.$i18n.messages[this.$i18n.locale] || this.$i18n.messages[this.$i18n.fallbackLocale]
      return messages.navMenu || {}
    },
    menus() {
      const menu = this.navMenu
      return [
        { key: 'series', title: this.$t('topWindow.seriesS'), path: '/series-s', groups: (menu.series && menu.series.groups) || [] },
        { key: 'support', title: this.$t('topWindow.support'), path: '/support', groups: (menu.support && menu.support.groups) || [] },
        { key: 'contact', title: this.$t('topWindow.contact'), path: '/contact', groups: (menu.contact && menu.contact.groups) || [] },
      ]
    },
  },
  watch: {
    '$route'() {
      this.closeAll()
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    window.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('keydown', this.onKeydown)
    this.clearCloseTimer()
  },
  methods: {
    onKeydown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        this.closeAll()
      }
    },
    onResize() {
      const mobile = window.innerWidth < 800
      if (mobile !== this.isMobile) {
        this.isMobile = mobile
        this.closeAll()
      }
    },
    openMenu(key) {
      this.clearCloseTimer()
      this.activeMenu = key
    },
    scheduleClose() {
      this.clearCloseTimer()
      this.closeTimer = setTimeout(() => {
        this.activeMenu = null
        this.mobileSection = null
      }, 180)
    },
    cancelClose() {
      this.clearCloseTimer()
    },
    clearCloseTimer() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer)
        this.closeTimer = null
      }
    },
    closeAll() {
      this.clearCloseTimer()
      this.activeMenu = null
      this.mobileOpen = false
      this.mobileSection = null
    },
    toggleMobile() {
      this.mobileOpen = !this.mobileOpen
      if (!this.mobileOpen) this.mobileSection = null
    },
    toggleMobileSection(key) {
      this.mobileSection = this.mobileSection === key ? null : key
    },
    // 统一生成带语言前缀的绝对路径，避免相对路径叠加语言段
    langPath(to) {
      const path = this.$route.path || ''
      const lang = path.startsWith('/en') ? 'en' : 'zh'
      return '/' + lang + (to === '/' ? '' : to)
    },
    changeLanguage(lan) {
      if (this.$i18n.locale === lan) return
      this.closeAll()
      const segments = (this.$route.path || '').split('/').filter(Boolean)
      if (segments[0] === 'zh' || segments[0] === 'en') {
        segments[0] = lan
      } else {
        segments.unshift(lan)
      }
      const newPath = '/' + segments.join('/')
      this.$i18n.locale = lan
      this.$router.replace(newPath).then(() => {
        window.location.reload()
      }).catch(() => {
        window.location.reload()
      })
    },
    routerpush(to) {
      this.closeAll()
      const path = (this.$route.path || '').replace(/\/+$/, '')
      const target = this.langPath(to)
      if (path === target) return
      this.$router.push(target).then(() => {
        window.location.reload()
      }).catch(() => {
        window.location.reload()
      })
    },
  },
}
</script>

<style lang="less" scoped>
@bar-height: 48px;
@bar-bg: rgba(255, 255, 255, 0.72); // 浅色毛玻璃：与白色正文更协调
@bar-bg-solid: rgba(255, 255, 255, 0.94);
@text: rgba(29, 29, 31, 0.86); // 导航文字
@text-strong: #000; // hover / 选中
@text-dim: rgba(29, 29, 31, 0.48); // 栏目标题
@text-link: rgba(29, 29, 31, 0.76); // 下拉链接
@text-weak: rgba(29, 29, 31, 0.42); // 分组小标题
@hairline: rgba(0, 0, 0, 0.08);
@scrim-bg: rgba(0, 0, 0, 0.28);
@panel-max-width: 1024px;

.nav-root {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}

.nav-shell {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
}

.nav-bar {
  position: relative;
  z-index: 3;
  height: @bar-height;
  background: @bar-bg;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border-bottom: 1px solid transparent;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
  transition: background 0.3s ease, border-color 0.3s ease;

  .nav-root.is-open & {
    background: @bar-bg-solid;
    border-bottom-color: @hairline;
  }
}

.nav-bar-inner {
  max-width: @panel-max-width;
  height: 100%;
  margin: 0 auto;
  padding: 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-logo {
  display: flex;
  align-items: center;
  height: 100%;
  padding-right: 8px;
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.82;
  }

  img {
    width: 26px;
    height: 26px;
    object-fit: contain;
  }
}

.nav-list {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 0 12px;
}

.nav-item {
  height: 100%;
  line-height: @bar-height;
  padding: 0 20px;
  font-size: 12px;
  letter-spacing: 0.02em;
  color: @text;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s ease;

  &:hover,
  &.is-active {
    color: @text-strong;
  }
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.nav-lang {
  font-size: 12px;
  line-height: @bar-height;
  color: @text-dim;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover,
  &.is-active {
    color: @text-strong;
  }
}

.nav-toggle {
  position: relative;
  width: 26px;
  height: @bar-height;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;

  span {
    position: absolute;
    left: 3px;
    right: 3px;
    height: 1.5px;
    background: @text;
    border-radius: 1px;
    transition: transform 0.32s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease;
  }

  span:first-child {
    top: 21px;
  }

  span:last-child {
    top: 27px;
  }

  &.is-open span:first-child {
    transform: translateY(3px) rotate(45deg);
  }

  &.is-open span:last-child {
    transform: translateY(-3px) rotate(-45deg);
  }
}

/* 下拉面板 */
.nav-panels {
  position: absolute;
  top: @bar-height;
  left: 0;
  right: 0;
  z-index: 2;
  pointer-events: none;
}

.nav-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
  background: @bar-bg-solid;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  transition: max-height 0.42s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.24s ease;

  &.is-open {
    max-height: 420px;
    opacity: 1;
    pointer-events: auto;
  }
}

.nav-panel-inner {
  max-width: @panel-max-width;
  margin: 0 auto;
  padding: 40px 22px 52px;
  display: flex;
  align-items: flex-start;
  gap: 72px;
  text-align: left;
  transform: translateY(-10px);
  opacity: 0;
  transition: transform 0.45s cubic-bezier(0.28, 0.11, 0.32, 1), opacity 0.3s ease;

  .nav-panel.is-open & {
    transform: translateY(0);
    opacity: 1;
    transition-delay: 0.06s;
  }
}

.nav-col {
  min-width: 150px;
}

.nav-col-title {
  margin: 0 0 14px;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.02em;
  color: @text-dim;
}

.nav-col-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.nav-col-link {
  font-size: 14px;
  line-height: 1.4;
  padding: 7px 0;
  color: @text-link;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;

  &:hover {
    color: @text-strong;
    transform: translateX(2px);
  }
}

/* 移动端菜单 */
.nav-mobile {
  position: fixed;
  top: @bar-height;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  padding: 6px 24px 48px;
  background: @bar-bg-solid;
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  overflow-y: auto;
  opacity: 0;
  transform: translateY(-10px);
  pointer-events: none;
  transition: opacity 0.3s ease, transform 0.36s cubic-bezier(0.28, 0.11, 0.32, 1);

  &.is-open {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }
}

.nav-mobile-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  font-size: 16px;
  color: @text;
  cursor: pointer;
  border-bottom: 1px solid @hairline;
}

.nav-mobile-arrow {
  width: 8px;
  height: 8px;
  margin-right: 6px;
  border-right: 1px solid rgba(29, 29, 31, 0.38);
  border-bottom: 1px solid rgba(29, 29, 31, 0.38);
  transform: rotate(45deg);
  transition: transform 0.3s ease;

  &.is-open {
    transform: rotate(-135deg);
  }
}

.nav-mobile-sub {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &.is-open {
    max-height: 1000px;
  }
}

.nav-mobile-group {
  margin: 18px 0 6px;
  font-size: 11px;
  letter-spacing: 0.04em;
  color: @text-weak;
}

.nav-mobile-link {
  display: block;
  padding: 9px 0;
  font-size: 13px;
  color: @text-link;
  cursor: pointer;

  &:hover {
    color: @text-strong;
  }
}

.nav-mobile-lang {
  display: flex;
  align-items: center;
  gap: 26px;
  margin-top: 30px;
  font-size: 13px;

  span {
    color: @text-dim;
    cursor: pointer;

    &.is-active {
      color: @text-strong;
    }
  }
}

/* 页面遮罩：菜单展开时压暗下方内容 */
.nav-scrim {
  position: fixed;
  top: @bar-height;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: @scrim-bg;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;

  &.is-open {
    opacity: 1;
    pointer-events: auto;
  }
}

@media only screen and (max-width: 799px) {
  .nav-bar-inner {
    padding: 0 18px;
  }

  .nav-logo img {
    width: 28px;
    height: 28px;
  }
}
</style>
